import React from "react";
import { InfoRow } from "./InfoRow";
import { useTranslation } from "react-i18next";
import { FormInstance } from "antd";

interface ContactInfoField {
  key: string;
  label: string;
  value: string;
  editable?: boolean;
}

interface ContactInfoProps {
  form: FormInstance<IVisaRequestFormData>;
  handleEditClick?: (field: string) => void;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ form, handleEditClick }) => {
  const { t } = useTranslation();

  const personalFields: ContactInfoField[] = [
    {
      key: "permanent_residental_address",
      label: t("registration_form.step4.residential_address"),
      value: form.getFieldValue("permanent_residental_address") || "",
      editable: true,
    },
    {
      key: "emergency_current_residental_address",
      label: t("registration_form.step4.emergency_residential_address"),
      value: form.getFieldValue("emergency_current_residental_address") || "",
      editable: true,
    },
    {
      key: "contact_address",
      label: t("registration_form.step4.contact_address"),
      value: form.getFieldValue("contact_address") || "",
      editable: true,
    },
    {
      key: "telephone_number",
      label: t("registration_form.step4.telephone_number"),
      value: form.getFieldValue("telephone_number") || "",
      editable: true,
    },
    {
      key: "emergency_fullname",
      label: t("registration_form.step4.emergency_fullname"),
      value: form.getFieldValue("emergency_fullname") || "",
      editable: true,
    },
    {
      key: "emergency_relationship",
      label: t("registration_form.step4.emergency_relationship"),
      value: form.getFieldValue("emergency_relationship") || "",
      editable: true,
    },
  ];

  return (
    <div className="max-w-7xl mx-auto py-4">
      <div className="grid grid-cols-1 md:grid-cols-2">
        {personalFields.map((field) => (
          <InfoRow
            key={field.label}
            fieldKey={field.key}
            label={field.label}
            value={field.value}
            editable={field.editable}
            handleEditClick={handleEditClick}
          />
        ))}
      </div>
    </div>
  );
};

export default ContactInfo;
